/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
// Internal deps
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import { getWorkReport, postLines } from '../../services/workReport';
import WorkReportModals from '../WorkReportModals/WorkReportModals';
import { useWorkReportModals } from '../../context/WorkReportModalsContext';
import { hasWorkReportMessage } from '../../constants/constants';
import {
  formatAmountDateBack,
  formatFullDate,
  getEndingDate,
  reverseFormatAmountDate,
  formatsEnum
} from '../../utils/formatUtils';
import useToast from '../../hooks/useToast';
import useWorkReport from '../../hooks/useWorkReport';
import { mapperPosLineArray } from '../../utils/mapper';
import {
  WorkPartPermissions,
  AttachedFilesPermissions
} from '../MonthlyServiceRequest/RequestDetailTypes';
import { useFilterContext } from '../../context/FilterDetailSDSContext';
import { useDrawerContext } from '../../context/DrawerContext';

import ViewOptionsContainer from './ViewOptionsContainer/ViewOptionsContainer';
import WorkReportHeader from './WorkReportHeader/WorkReportHeader';
import './WorkReports.scss';
import AddMultiplePLModal from './AddMultiplePLModal/AddMultiplePLModal';
import FilterWorkReport from './FilterWorkReports/FilterWorkReport';

const WorkReports = ({
  contractNumber,
  isASDS,
  workPartPermissions,
  typeOfUbication,
  disabledEditStateCancelOrFinish,
  filesPermissions,
  setIsPendingAuthorization,
  isOyM,
  notificaPP,
  asignationType,
  details
}) => {
  const { props, showModal, hideModal } = useWorkReportModals();
  const { activeTemplateWorkReportModal } = useWorkReportModals();
  const { id } = useParams();
  const { setNewToast } = useToast();
  const {
    workReportId,
    setWorkReportId,
    calendarDate,
    setCalendarDate,
    setEndDate,
    fetchLinesByDay,
    forceWindow
  } = useWorkReport();
  const defaultDays = 15;

  const { filter } = useFilterContext();

  const [numberDays, setNumberDays] = useState(defaultDays);
  const [endingDate, setEndingDate] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [createNewWorkReport, setCreateNewWorkReport] = useState(false);
  const [editDate, setEditDate] = useState(false);
  const [hasWorkReport, setHasWorkReport] = useState(false);
  const [hasLines, setHasLines] = useState(false);
  const [backupDates, setBackupDates] = useState(null);

  const [changeInLines, setChangeInLines] = useState(false);
  // newFetch is used in places to reload lines
  const [newFetch, setNewFetch] = useState(false);
  const [showModalAddLine, setShowModalAddLine] = useState(false);

  const [showModalOutOfRange, setShowModalOutOfRange] = useState(false);
  const [positions, setPositions] = useState([]);
  const [, setLoading] = useState(false);
  const { activeDrawer, setActiveDrawer, closeDrawer } = useDrawerContext();

  // When Certifications redirects to our detail it can send us
  // a line with its date and id to identify and highlight it
  const history = useHistory();
  const { template } = useLocation();

  const [templateActive, setTemplateActive] = useState(template || false);
  const [applyTemplate, setApplyTemplate] = useState(false);
  const queryParams = new URLSearchParams(history.location.search);
  const [fecha, setFecha] = useState(
    queryParams.get('fecha')
      ? formatFullDate(queryParams.get('fecha'), formatsEnum.FORMAT_DATE_2)
      : null
  );
  const idParteDiario = Number(queryParams.get('idParteDiario') || null);

  const handlerToSetCalendarDate = (fechaInicio, fechaFinaliza) => {
    const today = fecha ?? formatFullDate(new Date(), formatsEnum.FORMAT_DATE_2);
    const firstDay = formatFullDate(fechaInicio, formatsEnum.FORMAT_DATE_2);
    const lastDay = formatFullDate(fechaFinaliza, formatsEnum.FORMAT_DATE_2);

    // If today it`s between firstDay and lastDay
    // pick today, else pick lastDay
    const intialDay = today < lastDay && today >= firstDay ? today : lastDay;

    setCalendarDate(calendarDate || intialDay);
    setFecha(calendarDate);
  };

  const fetchWorkReport = async () => {
    try {
      const response = await getWorkReport(id);

      if (response.resultado) {
        setHasWorkReport(response.mensaje === hasWorkReportMessage);
        setHasLines(response.resultado.contieneLineas);
        setInitialDate(formatAmountDateBack(response.resultado.fechaInicio));
        setEndDate(response.resultado.fechaFinaliza);
        handlerToSetCalendarDate(response.resultado.fechaInicio, response.resultado.fechaFinaliza);
        setNumberDays(response.resultado.cantDias);
        setWorkReportId(response.resultado.id);
      } else {
        setHasWorkReport(false);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const mapPostLinesWorkReport = (values) => ({
    idParteTrabajo: workReportId,
    fechaInicio: new Date(initialDate),
    fechaFinaliza: new Date(reverseFormatAmountDate(endingDate)),
    posiciones: mapperPosLineArray(values).posiciones,
    lineas: mapperPosLineArray(values).lineas
  });

  const postLinesWorkReport = async (values) => {
    setLoading(true);
    const body = mapPostLinesWorkReport(values);

    try {
      const res = await postLines(body);

      setNewToast({
        type: 'SUCCESS',
        message: res.mensaje
      });
      fetchWorkReport();
      setShowModalAddLine(false);
      setNewFetch(!newFetch);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const onClose = () => {
    setShowModalAddLine(false);
  };

  const handleNewFetchLine = () => {
    fetchWorkReport();
    fetchLinesByDay(undefined, undefined, filter);
    setIsPendingAuthorization(false);
  };

  useEffect(() => {
    if (forceWindow !== null) handleNewFetchLine();
  }, [workReportId, forceWindow]);

  useEffect(() => {
    if (applyTemplate) handleNewFetchLine();
  }, [applyTemplate]);

  const fetchDataWithDefaultParams = () => {
    setApplyTemplate(true);
  };

  useEffect(() => {
    if (templateActive) {
      activeTemplateWorkReportModal({
        onAccept: fetchDataWithDefaultParams,
        monthly: undefined,
        applied: undefined,
        // Does the request have loaded lines?
        contractNumber,
        disabledEditStateCancelOrFinish
      });
      setTemplateActive(false);
    }
  }, [templateActive]);

  useEffect(() => {
    setCalendarDate(initialDate);
    if (forceWindow !== null) fetchLinesByDay(undefined, undefined, filter);
  }, [newFetch, forceWindow]);

  useEffect(() => {
    if (!!initialDate && !!numberDays) {
      setLoading(true);
      setEndingDate(getEndingDate(initialDate, Number(numberDays)));
    } else {
      setEndingDate(null);
    }
  }, [initialDate, numberDays]);

  useEffect(() => {
    if (fecha) setCalendarDate(formatFullDate(fecha, formatsEnum.FORMAT_DATE_2));
  }, [fecha]);

  return (
    <>
      <WorkReportHeader
        applyTemplate={workPartPermissions?.applyTemplate}
        backupDates={backupDates}
        contractNumber={contractNumber}
        createNewWorkReport={createNewWorkReport}
        disabledByRol={!workPartPermissions?.headerWorkPartASDS}
        disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
        editDate={editDate}
        endingDate={endingDate}
        hasLines={hasLines}
        hasWorkReport={hasWorkReport}
        initialDate={initialDate}
        isASDS={isASDS}
        numberDays={numberDays}
        setBackupDates={setBackupDates}
        setCreateNewWorkReport={setCreateNewWorkReport}
        setEditDate={setEditDate}
        setEndingDate={setEndingDate}
        setHasLines={setHasLines}
        setInitialDate={setInitialDate}
        setLoading={setLoading}
        setNewFetch={setNewFetch}
        setNumberDays={setNumberDays}
        setPositions={setPositions}
        setShowModalAddLine={setShowModalAddLine}
        setShowModalOutOfRange={setShowModalOutOfRange}
        uploadTemplate={handleNewFetchLine}
      />

      <div className="">
        <FilterWorkReport hide={closeDrawer} show={activeDrawer} />
        <ViewOptionsContainer
          asignationType={asignationType}
          changeInLines={changeInLines}
          details={details}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          endingDate={endingDate}
          filesPermissions={filesPermissions}
          hasLines={hasLines}
          idParteDiario={idParteDiario}
          initialDate={initialDate}
          isOyM={isOyM}
          newFetch={newFetch}
          notificaPP={notificaPP}
          positionLinesPermissions={workPartPermissions?.positionLine}
          setChangeInLines={setChangeInLines}
          setHasLines={setHasLines}
          setNewFetch={setNewFetch}
          setShowFilters={setActiveDrawer}
          typeOfUbication={typeOfUbication}
        />
      </div>
      <ModalGeneric
        backdrop="static"
        infoModal
        onHide={() => {
          setInitialDate(backupDates.initialDate);
          setNumberDays(backupDates.numberDays);
          setShowModalOutOfRange(false);
        }}
        primaryAction={() => {
          setInitialDate(backupDates.initialDate);
          setNumberDays(backupDates.numberDays);
          setShowModalOutOfRange(false);
        }}
        primaryActionLabel="Aceptar"
        show={showModalOutOfRange}
        size="md"
        title="Fuera de rango"
        variantHeader="warning"
      >
        <Row className="d-flex justify-content-center">
          <Col
            sm={12}
            style={{
              textAlign: 'center'
            }}
          >
            <strong>No es posible modificar el rango de días del parte de trabajo.</strong>
            <div>
              Para continuar revisá que no queden líneas con cantidades cargadas fuera del rango que
              estás eligiendo.
            </div>
          </Col>
        </Row>
      </ModalGeneric>

      <AddMultiplePLModal
        contractNumber={contractNumber}
        isWorkReport
        onCloseModal={onClose}
        onSubmitPL={postLinesWorkReport}
        positions={positions}
        showModal={showModalAddLine}
      />

      <WorkReportModals {...props} onHide={hideModal} showModal={showModal} />
    </>
  );
};

WorkReports.propTypes = {
  details: PropTypes.shape({}),
  contractNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isASDS: PropTypes.bool.isRequired,
  workPartPermissions: WorkPartPermissions.isRequired,
  typeOfUbication: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string
  }).isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  filesPermissions: AttachedFilesPermissions,
  setIsPendingAuthorization: PropTypes.func,
  isOyM: PropTypes.bool,
  notificaPP: PropTypes.bool.isRequired,
  asignationType: PropTypes.number.isRequired
};

WorkReports.defaultProps = {
  details: {},
  filesPermissions: {
    visualize: false,
    write: false
  },
  isOyM: false,
  setIsPendingAuthorization: () => {}
};

export default WorkReports;
